/* NRA product page: detail tabs, copy-SKU button, sticky purchase bar. */
(() => {
  // Tabs (delegated so they keep working after variant re-renders)
  const selectTab = (tab) => {
    const list = tab.closest('[role="tablist"]');
    const root = tab.closest('[data-nra-tabs]');
    if (!list || !root) return;
    list.querySelectorAll('[role="tab"]').forEach((t) => {
      const active = t === tab;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', String(active));
      t.tabIndex = active ? 0 : -1;
      const panel = root.querySelector(`#${t.getAttribute('aria-controls')}`);
      if (panel) panel.classList.toggle('is-active', active);
    });
  };

  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-nra-tabs] [role="tab"]');
    if (tab) selectTab(tab);

    const copy = e.target.closest('[data-nra-copy]');
    if (copy) {
      const value = copy.parentElement.querySelector('[data-nra-copy-value]')?.textContent.trim();
      if (!value || !navigator.clipboard) return;
      navigator.clipboard.writeText(value).then(() => {
        const label = copy.getAttribute('aria-label');
        copy.classList.add('is-copied');
        copy.setAttribute('aria-label', copy.dataset.copiedLabel || 'Copied');
        setTimeout(() => {
          copy.classList.remove('is-copied');
          copy.setAttribute('aria-label', label);
        }, 1600);
      });
    }
  });

  document.addEventListener('keydown', (e) => {
    const tab = e.target.closest('[data-nra-tabs] [role="tab"]');
    if (!tab || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    const tabs = [...tab.parentElement.querySelectorAll('[role="tab"]')];
    const next = tabs[(tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
    selectTab(next);
    next.focus();
    e.preventDefault();
  });

  // Sticky purchase bar: visible once the main Add to cart scrolls above the viewport
  // The buy buttons can be re-rendered by product-info.js, so look them up on every check.
  const initSticky = () => {
    const bar = document.querySelector('[data-nra-sticky]');
    if (!bar) return;
    bar.hidden = false;
    let queued = false;
    const update = () => {
      queued = false;
      const anchor = document.querySelector('.nra-pdp .product-form__buttons');
      const passed = !!anchor && anchor.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('is-visible', passed);
      document.body.classList.toggle('nra-sticky-open', passed);
    };
    const queue = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(update);
    };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    update();
  };

  // Sticky purchase column: sit below the header, or pin by its bottom edge when taller than the screen.
  const initSideColumn = () => {
    const side = document.querySelector('.nra-pdp__side');
    if (!side) return;
    const place = () => {
      const header = document.querySelector('.shopify-section-header-sticky, .section-header');
      const headerHeight = header ? header.getBoundingClientRect().height : 0;
      const fitsTop = headerHeight + 24;
      const bottomPinned = window.innerHeight - side.offsetHeight - 24;
      side.style.setProperty('--nra-side-top', `${Math.round(Math.min(fitsTop, bottomPinned))}px`);
    };
    place();
    window.addEventListener('resize', place);
    window.addEventListener('load', place);
    if ('ResizeObserver' in window) new ResizeObserver(place).observe(side);
  };

  const init = () => {
    initSticky();
    initSideColumn();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
